import React, { useEffect, useState } from 'react';
import { useCognitoAuth } from '../contexts/CognitoAuthContext';
import Calendar from './Calendar';
import NotificationSettings from './NotificationSettings';

type TabType = 'calendar' | 'settings';

const CognitoDashboard: React.FC = () => {
  const { user } = useCognitoAuth();
  const [activeTab, setActiveTab] = useState<TabType>('calendar');

  // Bridge Cognito tokens to old auth system for Calendar compatibility
  useEffect(() => {
    const cognitoToken = localStorage.getItem('cognito_access_token');
    if (cognitoToken && !localStorage.getItem('auth_token')) {
      localStorage.setItem('auth_token', cognitoToken);
    }
  }, []);

  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <h1>Welcome back, {user?.first_name}!</h1>
        <p>
          {activeTab === 'calendar'
            ? 'Click on any date to mark yourself as available for study sessions'
            : 'Manage your email notification preferences'
          }
        </p>
      </div>

      <div className="dashboard-nav">
        <button
          className={`nav-button ${activeTab === 'calendar' ? 'active' : ''}`}
          onClick={() => setActiveTab('calendar')}
        >
          📅 Calendar
        </button>
        <button
          className={`nav-button ${activeTab === 'settings' ? 'active' : ''}`}
          onClick={() => setActiveTab('settings')}
        >
          ⚙️ Settings
        </button>
      </div>

      <div className="dashboard-content">
        {activeTab === 'calendar' && <Calendar />}
        {activeTab === 'settings' && <NotificationSettings />}
      </div>
    </div>
  );
};

export default CognitoDashboard;